import React, { useEffect, useState } from 'react';
import { getPublicSiteMarketingConfig, joinMarketingUrl } from '../utils/publicSiteConfig';

/**
 * Full-page redirect to the static marketing site (rules, map, location).
 * @param {{ pathKey: 'rules' | 'map' | 'location' }} props
 */
function MarketingRedirect({ pathKey }) {
  const [message, setMessage] = useState('Redirecting…');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { marketingSiteBaseUrl, marketingPaths } = await getPublicSiteMarketingConfig();
        if (cancelled) return;
        const path = marketingPaths[pathKey] || '/';
        const url = joinMarketingUrl(marketingSiteBaseUrl, path);
        window.location.replace(url);
      } catch {
        if (!cancelled) setMessage('Could not load site configuration.');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [pathKey]);

  return (
    <div style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif', textAlign: 'center' }}>
      <p>{message}</p>
    </div>
  );
}

export default MarketingRedirect;
